export default {};

export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'hh:mm A';
export const TIME_FORMAT_24H = 'HH:mm';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD hh:mm';

// Luxon format constants (lowercase 'yyyy' for Luxon vs uppercase 'YYYY' for moment)
export const LUXON_DATE_FORMAT = 'yyyy-MM-dd';
export const LUXON_TIME_FORMAT = 'h:mm a';
export const LUXON_TIME_FORMAT_24H = 'HH:mm';

export const LABOUR_PROJECT_BILLING_FIELD_TYPES = [
  'regularBillingRate',
  'otBillingRate',
  'dtBillingRate',
];

export const DEFAULT_FIELD_TYPES = [
  'user',
  'date',
  'type',
  'division',
  'project',
  'phase',
  'costcode',
  'local',
  'class',
  'sageShift',
  'hourBased',
  'time',
  'note',
  'status',
  'enteredVia',
  'formattedDuration',
  'formattedStartTime',
  'formattedEndTime',
  'hourlyBillingRate',
  'userWage',
  'hourlyCost',
  'dailyCost',
  'excludeFromAutoBreak',
  'isNightShift',
  'regularHours',
  'otHours',
  'doubleOTHours',
];

export const EDITABLE_DEFAULT_FIELD_TYPES = [
  'date',
  'type',
  'project',
  'phase',
  'costcode',
  'hourBased',
  'time',
  'note',
  'class',
  'local',
  'hourlyBillingRate',
  ...LABOUR_PROJECT_BILLING_FIELD_TYPES,
  'userWage',
  'hourlyCost',
  'dailyCost',
  'formattedStartTime',
  'formattedEndTime',
  'excludeFromAutoBreak',
  'isNightShift',
  'regularHours',
  'otHours',
  'doubleOTHours',
];

export const getEditableDefaultFieldTypes = (isMultiDivision) => (
  isMultiDivision ? [...EDITABLE_DEFAULT_FIELD_TYPES, 'division'] : EDITABLE_DEFAULT_FIELD_TYPES
);

export const EDITABLE_CUSTOM_FIELD_TYPES = new Set([
  'text',
  'yes-no',
  'calculation',
  'dropdown',
  'dateRange',
  'dateTime',
  'attribute',
]);

export const TIME_ENTRY_PERMISSION_EXCLUDED_COLUMNS = new Set([
  'date',
  'user',
  'project',
  'phase',
  'costcode',
  'time',
]);

export const SHOW_INPUT_TYPES = new Set([
  'startEndTime',
  'switch',
]);

export const FIELDS_THAT_TRIGGER_AUTO_BREAK_RECOMPUTE = new Set([
  'date',
  'startTime',
  'endTime',
  'excludeFromAutoBreak',
  'time',
  'regularHours',
  'otHours',
  'doubleOTHours',
]);
